import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const CapsRoute = props => {
  const { isCapsAdmin, isCapsSupervisor, isCapsOperador, isCapsConsulta, isCapsDocs, isCapsDocsEsp, isTodosCapsConsulta } = useContext(UserContext);

  if (isCapsAdmin || isCapsSupervisor || isCapsOperador || isCapsConsulta || isCapsDocs || isCapsDocsEsp || isTodosCapsConsulta) {
    return <Route {...props} />;
  } else if (!isCapsAdmin || !isCapsSupervisor || !isCapsOperador || !isCapsConsulta || !isCapsDocs || !isCapsDocsEsp || !isTodosCapsConsulta) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default CapsRoute;
// TODO caps